import { Commit, Dispatch } from 'vuex';
import { EditStore } from '@/main/store/@types/edit.d';

import { edit, dropdownList, localState, props } from './state';

type State = EditStore<typeof edit, typeof dropdownList, typeof localState, {}, typeof props>;
type VuexProps = { commit: Commit, dispatch: Dispatch, state: State };

export const actions = <const>{
};
